import { format, differenceInYears } from 'date-fns';
import { ru } from 'date-fns/locale';
import { VueConstructor } from 'vue';
import { UserDTO, BodyDTO } from '@/api';

export default {
  install(Vue: VueConstructor) {
    Vue.filter('date', (value: number) => value && format(value, 'dd.MM.yyyy'));
    Vue.filter('fullDate', (value: number) => value && format(value, 'dd MMMM yyyy', { locale: ru }));
    Vue.filter('fullDateTime', (value: number) => value && format(value, 'dd MMMM yyyy hh:mm', { locale: ru }));
    Vue.filter('shortDate', (value: number) => value && format(value, 'dd MMMM', { locale: ru }));
    Vue.filter('currency', (value: string) => parseFloat(value).toLocaleString('ru-RU'));
    Vue.filter('currencyShort', (value: number) => {
      const prefix = value % 1000 > 0 ? '~' : '';
      return value > 10000 ? `${prefix}${Math.trunc(value / 1000)}K` : `${value}₽`;
    });
    Vue.filter('bodySize', (body: BodyDTO) => `${body.chest}-${body.waist}-${body.hips}`);
    Vue.filter('birthday', (value: number) => (value
      ? `${format(value, 'dd.MM.yyyy')} (${differenceInYears(new Date(), value)} года)`
      : ''));
    Vue.filter('fullName', (user: UserDTO) => (user ? [user.surname, user.firstName].join(' ') : null));
    Vue.filter('cutTagText', (val: string) => (val.length > 30 ? `${val.substring(0, 27)}...` : val));
  },
};
